import { render, staticRenderFns } from "./Func138TrocarSenha.vue?vue&type=template&id=3a54ee3b&scoped=true"
import script from "./Func138TrocarSenha.vue?vue&type=script&lang=js"
export * from "./Func138TrocarSenha.vue?vue&type=script&lang=js"
import style0 from "./Func138TrocarSenha.vue?vue&type=style&index=0&id=3a54ee3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a54ee3b",
  null
  
)

export default component.exports